import React from 'react'
import { Link } from 'react-router-dom'

function Home() {
  return (
    <section className='section-container'>
      <h2>Technical task</h2>
      {/* <Link to={'pers_projects/transport_service/book_ride'}>Book a ride</Link> */}
      <h5>Tools used</h5>
      <p>
        With this create react app I used : <br/>
        - useContext and useReducer to manage the state of the fetching <br/>
        - errorBoundary to gracefully handle any issues <br/>
        - react-router-dom, although I didn't make much use of this
      </p>
      <h5>To improve</h5>
      <p>
        This app could benefit from having some tests, such as Jest tests. <br/>
        I try to include Jest or RSpec (Ruby) when developing apps. This provides a reference <br/>
        for refactoring, but also helps other developers work together without making breaking changes.
        <br/>
        <br/>
        To improve this app I would have added more pages, including a reservations page with all
        booked trips for that session. This could be useful if someone needs a recap of all the trips booked.
        <br/>
        <br/>
        It could have been possible to include a map (such as provided by mapbox), however that
        would have been slightly off topic for this exercise.
      </p>
    </section>
  )
}

export default Home
